// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SimulationTrackerInput
 */
export interface SimulationTrackerInput {
  /**
   *
   */
  simulationId: number;
}

/**
 * Check if a given object implements the SimulationTrackerInput interface.
 */
export function instanceOfSimulationTrackerInput(value: object): value is SimulationTrackerInput {
  if (
    (!("simulationId" in (value as Record<string, any>)) &&
      !("simulation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["simulationId"] === undefined &&
      (value as Record<string, any>)["simulation_id"] === undefined)
  )
    return false;
  return true;
}

export function SimulationTrackerInputFromJSON(json: any): SimulationTrackerInput {
  return SimulationTrackerInputFromJSONTyped(json, false);
}

export function SimulationTrackerInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationTrackerInput {
  if (json == null) {
    return json;
  }
  return {
    simulationId: json["simulation_id"],
  };
}

export function SimulationTrackerInputToJSON(json: any): SimulationTrackerInput {
  return SimulationTrackerInputToJSONTyped(json, false);
}

export function SimulationTrackerInputToJSONTyped(
  value?: SimulationTrackerInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    simulation_id: value["simulationId"],
  };
}
